import type { FaireProductEntity } from "../../entity_types/product";

export const p_yxmjcntcm2: FaireProductEntity = {
  token: "p_yxmjcntcm2",
  type: "product",
  name: "I Like Cats More Than People Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/5f94b426081e44be8f9dad18b2e16a56966651023740456d8e6af6f8afdd2057.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/43b21d44c0097a9245ac08a0be0d4b07c4d928ab118b84664cac7076d1e36dfa.jpeg",
    "https://cdn.faire.com/fastly/41d3bba0ae09a466a4f2dfc779d5ae94db2e94daa5b5c2ec4e2182197331bb26.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/3b47f46d45d34c844ee2af21e923ae0d3bb3a2e24da51fcce31d0cb5a10d93a6.jpeg",
    "https://cdn.faire.com/fastly/be8e95f54efc1b58766db8a090b81869040a7c7fed136059e6c27d49927f6623.jpeg",
    "https://cdn.faire.com/fastly/758b5c8f4351287cff3f64e4e16e8a5cb0339ec7a7b2f78a9ae5d975ff078764.jpeg",
    "https://cdn.faire.com/fastly/c7a48cf31cc7f570bea07a3892d7a7f3cc461302b7e5f254687f93a2d5cf9f00.jpeg",
    "https://cdn.faire.com/fastly/b5bb2d39ec4ea715cc6a333280c1ecd8f047d90d5d75a6a1ef9c4c37f7c17633.jpeg"
  ],
  priceDollars: 6.75,
  description: "Soft, cozy, and brutally honest—these socks let everyone know you prefer feline fellowship. Perfect for lounging, ignoring texts, and collecting just the right amount of fur.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:27:53.968Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
